import ACTION_TYPES from '../../constants/actionTypes';
import * as analytics from '../../services/analytics';
import sureAxios from '../../services/sureAxios';
import api from '../../api';

/**
 * Send login link
 */

function sendLoginLinkRequest(email) {
  return {
    type: ACTION_TYPES.SEND_LOGIN_LINK,
    payload: {
      email,
    },
  };
}

function sendLoginLinkSuccess() {
  return {
    type: ACTION_TYPES.SEND_LOGIN_LINK_SUCCESS,
  };
}

function sendLoginLinkFailure(error) {
  return {
    type: ACTION_TYPES.SEND_LOGIN_LINK,
    error,
  };
}

export function sendLoginLink(email) {
  return (dispatch) => {
    dispatch(sendLoginLinkRequest(email));
    return new Promise((resolve, reject) => {
      api
        .sendLoginLink(email)
        .then(() => {
          dispatch(sendLoginLinkSuccess());
          resolve();
        })
        .catch((error) => {
          dispatch(sendLoginLinkFailure(error.response.body.error));
          reject(error.response.body.error);
        });
    });
  };
}

/**
 * Login
 */

function loginRequest(token) {
  return {
    type: ACTION_TYPES.LOGIN,
    payload: {
      token,
    },
  };
}

function loginSuccess(session) {
  analytics.identify(session);
  sureAxios.defaults.headers['Authorization'] = `Bearer ${session.auth.token}`;
  return {
    type: ACTION_TYPES.LOGIN_SUCCESS,
    payload: {
      ...session,
      authType: 'Bearer',
    },
  };
}

function loginFailure(error) {
  return {
    type: ACTION_TYPES.LOGIN_FAILURE,
    error,
  };
}

export function login(token) {
  return (dispatch) => {
    dispatch(loginRequest(token));
    return new Promise((resolve, reject) => {
      api
        .login(token)
        .then((session) => {
          resolve(session);
          dispatch(loginSuccess(session));
        })
        .catch((error) => {
          reject(error);
          dispatch(loginFailure(error));
        });
    });
  };
}

/**
 * Logout
 */

export function logout() {
  analytics.identify();
  delete sureAxios.defaults.headers['Authorization'];
  return {
    type: ACTION_TYPES.LOGOUT,
  };
}

/**
 * Save anonymous token
 */

export function saveAnonymousToken(token) {
  sureAxios.defaults.headers['Authorization'] = `Bearer ${token}`;
  return {
    type: ACTION_TYPES.SAVE_ANONYMOUS_TOKEN,
    payload: {
      token,
    },
  };
}
